import { Component } from '@angular/core'

import TranslateService from '../../../core/translate.service'

interface InformationWrapperItem {
  header: string
  body: string
}

interface InformationWrapper {
  alertHeader: string
  alertBody: string
  infoHeader: string
  infoItems: InformationWrapperItem[]
}

@Component({
  selector: 'app-psp-container-wrapper',
  templateUrl: './psp-container-wrapper.component.html',
  styleUrls: ['./psp-container-wrapper.component.scss'],
})
export default class PspContainerWrapperComponent {
  constructor(private translate: TranslateService) {}

  get informationWrapper(): InformationWrapper {
    return this.translate.data['information-wrapper'] || {
      alertHeader: '',
      alertBody: '',
      infoHeader: '',
      infoItems: [],
    }
  }
}
